(function () {
  function initHeroVideos() {
    const videos = document.querySelectorAll('[class*="floven-media-overlay-video-"]');

    videos.forEach((video) => {
      // If we've already processed this video (section reloads), skip
      if (video.dataset.heroInit === '1') return;
      video.dataset.heroInit = '1';

      // Ensure hidden until we KNOW it's playing
      video.classList.remove('is-playing');

      // If the theme/Liquid ever adds a poster attribute again, remove it to prevent flashing
      const posterAttr = video.getAttribute('poster');
      if (posterAttr && !video.dataset.poster) video.dataset.poster = posterAttr;
      video.removeAttribute('poster');

      const showVideo = () => video.classList.add('is-playing');

      // When playback actually starts, reveal it
      video.addEventListener('playing', showVideo, { once: true });
      video.addEventListener('timeupdate', showVideo, { once: true }); // extra safety

      const playPromise = video.play();

      // If autoplay is blocked / low power mode: replace with fallback image
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          const poster = video.dataset.poster;
          if (!poster) return;

          const img = document.createElement('img');
          img.src = poster;
          img.className = video.className.replace('floven-media-overlay-video', 'floven-media-overlay-media');
          img.alt = '';
          img.loading = 'eager';
          img.fetchPriority = 'high';
          img.decoding = 'async';
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';

          video.replaceWith(img);
        });
      } else {
        // Older browsers: if it doesn't start quickly, fallback
        setTimeout(() => {
          if (!video.paused && video.currentTime > 0) return; // it started
          const poster = video.dataset.poster;
          if (!poster) return;

          const img = document.createElement('img');
          img.src = poster;
          img.className = video.className.replace('floven-media-overlay-video', 'floven-media-overlay-media');
          img.alt = '';
          img.loading = 'eager';
          img.fetchPriority = 'high';
          img.decoding = 'async';
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';

          video.replaceWith(img);
        }, 600);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideos);
  } else {
    initHeroVideos();
  }

  document.addEventListener('shopify:section:load', initHeroVideos);
})();
